import { Types } from "../action/action";


interface DropBoxState {
  dropBoxFiles:Array<any>;
}

const initialState = {
  dropBoxFiles:[]
};

const DropBoxStorageReducerState = (state:DropBoxState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.GET_DROPBOX_FILES:
    return {
      ...state, dropBoxFiles: payloads
    };
  default:
    return state;
  };
};

export default DropBoxStorageReducerState;